import React, { memo } from "react";
import Select from "@ui/Select";
import t from "../../../../../../../../../i18n";
import { useLayerUpdateColorEncoding } from "../hook/useLayerUpdateColorEncoding";

export const MarkerInfoSelect = memo(
  ({
    projectId,
    options,
    className,
  }: {
    projectId: string;
    options: { label: string; value: string }[];
    className?: string;
  }) => {
    const { layerEncodingColor, updateLayerEncodingColor } = useLayerUpdateColorEncoding({
      projectId,
    });

    return (
      <Select
        prompt={t("project.dashboard.editor.gui.section.display.marker_info.empty")}
        label={t("project.dashboard.editor.gui.section.display.marker_info.title")}
        options={options}
        value={layerEncodingColor}
        onChange={e => {
          updateLayerEncodingColor(e.target.value);
        }}
        className={className}
        tooltipOverlay={t("tooltip.editor.plot.marker_info")}
      />
    );
  },
);
